const skuToIgnoreCOD = [];
const skuToAppendCOD = ["45053844062514", "45053844029746", "45053843996978", "47244318376242", "45053843931442", "47350002712882", "47349988131122", "45053843898674", "45053843865906","49287480639794"]

window.checkCODAvailability = function (skuList) {
  let ignoreCOD = false;
  let appendCOD = false;

  if (!Array.isArray(skuList)) {
    return null;
  }

  for (let i = 0; i < skuList.length; i++) {
    const currentSKU = skuList[i];
    if (typeof currentSKU !== "string") {
      return null;
    } else {
      if (skuToIgnoreCOD.includes(currentSKU)) {
        ignoreCOD = true;
      }
    }
  }

  if (skuToAppendCOD.length > 0 && skuList.length > 0) {
    appendCOD = skuList.every((element) => skuToAppendCOD.includes(element));
  }

  if (ignoreCOD) {
    return false;
  }

  if (!ignoreCOD && appendCOD) {
    return true;
  }

  return null;
};

window.filterCODPaymentOptions = function filterCODPaymentOptions(
  shopConfiguration,
  codAvailability
) {
  const rawShopConfig = JSON.parse(shopConfiguration);
  const shopPaymentMethodsConfig = rawShopConfig?.paymentMethodsConfig;
  if (shopPaymentMethodsConfig) {
    if (!codAvailability) {
      const paymentMethodsConfig = shopPaymentMethodsConfig.filter(
        (method) => !(method.title === 'CASH')
      );
      const updatedShopConfig = JSON.stringify({
        ...rawShopConfig,
        paymentMethodsConfig
      });
      return updatedShopConfig;
    }
    if (codAvailability) {
      const paymentMethodsConfig = shopPaymentMethodsConfig.filter(
        (method) => !(method.title === 'CASH')
      );
      const cashPaymentMethod = {
        title: 'CASH',
        paymentOptions: [
          {
            image: 'https://sdk.breeze.in/gallery/icons/cash/CASH.webp',
            label: 'Cash On Delivery',
            widget: 'cash',
            description: 'Pay on Delivery',
            type: 'Group',
            source: 'PSR',
            pmt: 'CASH',
            route: 'CASH',
            stateMeta: 'Pay ₹<b> {{totalPayableAmount}} </b> on delivery including convenience fee'
          }
        ]
      };
      paymentMethodsConfig.push(cashPaymentMethod);
      const updatedShopConfig = JSON.stringify({
        ...shopConfiguration,
        paymentMethodsConfig
      });
      return updatedShopConfig;
    }
  }
  return shopConfiguration;
}



